import Axios from "axios"
import { sortCaret } from "../../../_metronic/_helpers";
import React from "react"
//const url_employees = "http://localhost:5000/gt-out/us-central1/api/v1/employees";
const url_employees = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/employees";

export const columns = [
  {
    dataField: "count",
    text: "No",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "image",
    text: "Image",
    sort: true,
    sortCaret: sortCaret,

    rowStyle: {
      height: "100px"
    },
    formatter: (cell, row, i, addons = {}) => {
      return (
        <img
          alt="product"
          className="image-fluid rounded cursor-pointer"
          height="90px"
          onClick={() => typeof addons.controller === "function" && addons.controller(row)}
          width="90px"
          src={row.image_url || "https://firebasestorage.googleapis.com/v0/b/gto-mkt-dev.appspot.com/o/user.jpeg?alt=media&token=f8f556df-5d8c-4cc9-b9cd-669346e0d584"}
        />
      )
    }
  },
  {
    dataField: "last_login",
    text: "Last Login",
    sort: true,
    sortCaret: sortCaret,
    // sortCaret: sortCaret,
    // headerSortingClasses,
  },
  {
    dataField: "name",
    text: "Firstname",
    sort: true,
    sortCaret: sortCaret,
    // sortCaret: sortCaret,
    // headerSortingClasses,
  },
  {
    dataField: "last_name",
    text: "Lastname",
    sort: true,
    sortCaret: sortCaret,
    // sortCaret: sortCaret,
    // headerSortingClasses,
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
    sortCaret: sortCaret,
    // sortCaret: sortCaret,
    // headerSortingClasses,
  },
  {
    dataField: "phone",
    text: "Phone",
    sort: true,
    sortCaret: sortCaret,
    // sortCaret: sortCaret,
  }
];

export function getClients(setClients) {
  Axios.get(`${url_employees}/find`)
    .then((res) => {
      const employees = res.data.payload;
      setClients(employees);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
        console.log(`request cancelled:${thrown.message}`)
      } else {
        console.log('another error happened')
      }
    })
}
export function getClient(uid) {
  return Axios.get(`${url_employees}/find/${uid}`)

}
export function updateClient(employee) {
  if (employee.uid) {

    return Axios.put(`${url_employees}/update/${employee.uid}`, employee);
  } else {
    return Axios.post(`${url_employees}/create`, employee);

  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_employees}/delete/${uid}`)
}